import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import RequestServiceInfoSection from "./RequestServiceInfoSection";
import AlacarteServiceInfoSection from "../alacarteRequestDetailPage/AlacarteServiceInfoSection";
import OrderServiceInfoSection from "./OrderServiceInfoSection";

const RequestInfoSection = ({ request }) => {

  // Burayı satırı hiçbir şekilde silme
  if (!request) return (<>Request Not Found</>);

  return (
    <div>
      <RequestServiceInfoSection
        serviceName={request.serviceName}
        requestStaffSummary={request.staff_summary}
        requestFiles={request.files}
      />

      {request.service_type === "ORDER" &&
        <OrderServiceInfoSection
          requestOrderNumber={request.order_number}
          requestServiceType={request.service_type}
        />
      }

      {request.service_type === "ALACARTE_RESTAURANT_RESERVATION" &&
        <AlacarteServiceInfoSection request={request} />
      }
    </div>
  );
};

const mapStateToProps = () => ({});

const mapActionsToProps = {
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(RequestInfoSection)
);
